import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import { OrdersListSummary } from "@/model/OrdersListSummary";
import { PreparationOrdersBreakdown } from "@/model/preparation/PreparationOrdersBreakdown";

export class PreparationOrdersEvent implements Serializable {
  storeId: string;
  updateDate: Date;
  isKeepAlive: boolean;

  summary: OrdersListSummary;
  orders: PreparationOrdersBreakdown;

  fromJSON(rawObject: any): void {
    SerializationHelper.copyNonExcludedProperties(this, rawObject, ["summary", "orders"]);
    if (rawObject["summary"] != null) {
      this.summary = SerializationHelper.toInstanceFromJsonObj(new OrdersListSummary(), rawObject["summary"]);
    }
    if (rawObject["orders"] != null) {
      this.orders = SerializationHelper.toInstanceFromJsonObj(new PreparationOrdersBreakdown(), rawObject["orders"]);
    }
  }
}
